<template>
  <div class="app-text" v-html="txt"></div>
</template>
<script>
export default{
  data(){
    return{
      id:this.$route.query.id,
      txt:''
    }
  },
  mounted(){
    if(this.id == 1) document.title = '注册协议'
    if(this.id == 2) document.title = '积分说明'
    if(this.id == 4) document.title = '会员说明'
    if(this.id == 5) document.title = '价格说明'
    this.getPage();
  },
  methods:{
    getPage(){
      let vm = this;
      vm.ajax("page", "get", 'id='+vm.id, e => {
        vm.txt = e.data.content
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/protocol.vue